<template>
    <MonitorLayoutTemplate
        table_title="風景區警戒總覽"
        :show_search_text="false"
    >
        <template #description>
            <div class="signs__description">
                <span v-for="([text, icon]) in Object.entries(icons)" 
                    :key="text"
                >
                    <v-icon :class="`multiple-signal--${icon.color}`">
                        {{ icon.name }}
                    </v-icon>
                    {{ text }}
                </span>
            </div>
        </template>

        <template #signs>
            <MonitorMultipleSigns v-if="sign_data"
                :data="sign_data"
            />
        </template>

        <template #data_table>
            <ScenicAreaMonitor
                :key="default_value_weather"
                :default_value="default_value_weather"
                :table_data="table_data_weather"
                @transfer_immutable_table_data="get_immutable_table_data_weather"
            />
            <ScenicAreaMonitor
                :key="default_value_buoy"
                :default_value="default_value_buoy"
                :table_data="table_data_buoy"
                @transfer_immutable_table_data="get_immutable_table_data_buoy"
            />
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { 
        add_gust_interval_label_callback,
        sort_by_column,
    } from '@/utils/monitor/common_tool.js'
    import { 
        icons,
        reconstruct_signs_structure,
        merge_data_by_item,
        merge_by_property,
    } from "@/utils/monitor/customization/scenic.js"
    import {
        reconstruct_alert_icon,
    } from '@/utils/monitor/multiple_signs.js'
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import MonitorMultipleSigns from "@/components/monitor/_tool/monitor_multiple_signs.vue";
    import ScenicAreaMonitor from "@/components/monitor/common/scenic_area_monitor.vue"
    
    export default {
        name: 'ScenicAreaAlert',

        components: {
            MonitorLayoutTemplate,
            MonitorMultipleSigns, 
            ScenicAreaMonitor
        },

        data() {
            return {
                immutable_table_data_weather: [],
                immutable_table_data_buoy: [],
                table_data_weather: [],
                table_data_buoy: [],

                default_value_weather: 160,
                default_value_buoy: 157,

                icons: icons,
            }
        },
        
        computed: {
            sign_data() {
                if (this.table_data_weather.length !== 0 || this.table_data_buoy.length !== 0) {   
                    const sign_data_weather = reconstruct_signs_structure(merge_data_by_item(this.table_data_weather))
                    const sign_data_buoy = reconstruct_signs_structure(merge_data_by_item(this.table_data_buoy))
                    return merge_by_property(sign_data_weather, sign_data_buoy, "idx", ["sign_icons"])
                        .sort(sort_by_column('idx_for_sort'))
                }

                return []
            },
        },

        methods: {
            get_immutable_table_data_weather(data_from_child) {
                const has_gust_interval_label_data = data_from_child.map(add_gust_interval_label_callback('瞬間風(級)'))
                this.immutable_table_data_weather = has_gust_interval_label_data
                this.table_data_weather = reconstruct_alert_icon(has_gust_interval_label_data, icons)
                    .sort(sort_by_column('項次'))
                    .sort(sort_by_column('alert_order'))
                console.log(this.table_data_weather)
            },
            
            get_immutable_table_data_buoy(data_from_child) {
                this.immutable_table_data_buoy = data_from_child
                this.table_data_buoy = reconstruct_alert_icon(data_from_child, icons)
                    .sort(sort_by_column('項次'))
                    .sort(sort_by_column('alert_order'))
            },

            sort_by_column(column_key) {
                return (a,b) => a[column_key] - b [column_key]
            },
        },

    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/monitor/sign';

    .signs {
        &__description {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
        }
    }
</style>